angular.module('v3sWbtPlayerApp').factory('v3sI18nService', ["$interpolate", "v3sSupportedLanguages", "v3sLoaderService", function ($interpolate, v3sSupportedLanguages, v3sLoaderService) {
    var textLibrary = null;
    var textLibraryLoader = null;

    function setLanguage(lang) {
        if (!lang) {
            lang = navigator.language || navigator.userLanguage;
        }

        var language = getSupportedLanguage(lang);
        if (!!language) {
            Globalize.culture(lang);
            textLibraryLoader = v3sLoaderService(v3sSupportedLanguages[language], './app/language/').then(function (library) {
                textLibrary = library;
            });
        }
    }

    function loadLibrary() {
        if (!!textLibrary) {
            return true;
        } else {
            if (!textLibraryLoader) {
                setLanguage();
            }
            return textLibraryLoader;
        }
    }

    function getSupportedLanguage(lang) {
        var tmpLang = lang;
        while (!!tmpLang && !(tmpLang in v3sSupportedLanguages)) {
            var strLength = tmpLang.lastIndexOf("-");
            if (strLength > 0) {
                tmpLang = tmpLang.slice(0, strLength);
            } else {
                tmpLang = "en";
            }
        }
        return tmpLang;
    }

    function parseFloat(f) {
        return Globalize.parseFloat(f);
    }

    function formatNumber(n) {
        return Globalize.format(n, "N");
    }

    function processPlaceholders(txt, placeholders) {
        var interpolate = $interpolate(txt);
        return interpolate(placeholders);
    }

    /**
     * @param key - the key for the text resource or an array of keys
     * @param placeholders - associative array of placeholders and the corresponding values
     * @description
     * If an array is given as text, the function returns the first text from
     * If nothing is found, the last searchterm is returned
     */
    function getText(key, placeholders) {
        var translatedText = null;
        if (typeof key == 'string') {// a string was given
            if (!!textLibrary && typeof textLibrary.entries[key] !== 'undefined') {
                translatedText = textLibrary.entries[key];
            } else {
                translatedText = key;
            }
        } else if (typeof key == 'object') {// an array was given
            for (var i = 0; i < key.length; i++) {
                if (typeof textLibrary.entries[key[i]] !== 'undefined') {
                    translatedText = textLibrary.entries[key[i]];
                    break;
                } else {
                    translatedText = key[i];
                }
            }
        } else {
            throw "Wrong type. Should be string or object (array)";
        }

        return processPlaceholders(translatedText, placeholders);
    }

    /**
     * @param timestamp - timestamp in ms
     * @description
     * Return formatted date
     */
    function getDate(timestamp, format) {
        var date = timestamp ? new Date(timestamp) : new Date();
        format = !!format ? format : "d";
        return Globalize.format(date, format);
    }

    /**
     * @param timestamp - timestamp in ms
     * @description
     * Return formatted time
     */
    function getTime(timestamp) {
        return getDate(timestamp, "T");
        var date = timestamp ? new Date(timestamp) : new Date();
    }

    return {
        parseFloat: parseFloat,
        loadLibrary: loadLibrary,
        getText: getText,
        getDate: getDate,
        getTime: getTime,
        setLanguage: setLanguage,
        getCulture: function () { return Globalize.findClosestCulture() }
    }
}]);
